// extracted by mini-css-extract-plugin
export var errorsContainer = "_sc-1";
export var link = "_sc-0";